// external imports
import { Component, OnInit, OnDestroy, Input, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { VideoMsgMngrService } from '@core_n/msg/video-mngr.service';
import { SensorCoreObject } from '@core_n/asp/SensorCoreObject';
import { AlertMsgMngrService } from '@core_n/msg/alert-msg-mngr.service';
import { BoundingBox } from '@core_n/common/boundingBox';

@Component({
  selector: 'app-jwplayer-overlay',
  templateUrl: './jwplayer-overlay.component.html',
  styleUrls: ['./jwplayer-overlay.component.scss']
})

export class JWPlayerOverlayComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('overlayCanvas') canvasRef!: ElementRef<HTMLCanvasElement>;

  @Input('sensor') public sensor: SensorCoreObject; // not sure is needed..

  @Input('width') width: number = 640;
  @Input('height') height: number = 360;

  constructor(protected bboxService: AlertMsgMngrService) { }

  ngOnInit(): void {
    this.bboxService.subscribeMe(this.sensor.streamName, this.handleBoxUpdate.bind(this));
  }

  ngAfterViewInit(): void {
    const canvas = this.canvasRef.nativeElement;
    canvas.width = this.width;
    canvas.height = this.height;
  }

  ngOnDestroy(): void {
    this.bboxService.unSubscrbeMe(this.sensor.streamName);
  }

  handleBoxUpdate(box: BoundingBox) {
    const canvas = this.canvasRef.nativeElement;
    canvas.width = this.width;
    canvas.height = this.height;
    const ctx = canvas.getContext('2d');
    if (!ctx)
      return; // print error maybe???

    ctx.clearRect(0, 0, this.width, this.height);
    const scaled = box.scaleTo(this.width, this.height);

    ctx.strokeStyle = 'red';
    ctx.lineWidth = 2;
    ctx.strokeRect(scaled.x, scaled.y, scaled.width, scaled.height);
    // ctx.fillRect(0, 0, 100, 60);

  }

  makedrawing() {
    const canvas = this.canvasRef.nativeElement;
    canvas.width = this.width;
    canvas.height = this.height;

    const ctx = canvas.getContext('2d');
    if (ctx) {
      ctx.fillStyle = 'rgba(255,0,0,0.5)';
      ctx.fillRect(0, 0, 100, 60);
      console.log("canvas loaded right....");
    }
    else {
      console.log("canvas not loaded right....");
    }
  }
}